var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mail"},[_vm._v(" mail[a]quentinleman.com ")])}
var staticRenderFns = []

export { render, staticRenderFns }